import {
  animateLabel,
  resetSelect
} from './modules/selects_helper';

function checkSelectWithAimatedLabel(select) {
  if (select.val()) {
    animateLabel(select.closest('.mobile-animate-wrapp').get(0));
    animateLabel(select.next().get(0));
  }
}

$(function () {
  var carTypeRadio  = $('.listing-car-type-radio');
  var mobileSelects = $('.mobile-animate-wrapp');
  var makeSelect    = $('.listing-brand-select');
  var modelSelect   = $('.listing-model-select');
  var bodySelect    = $('.listing-body-select');

  var selectedCarType   = carTypeRadio.length === 0 ? $('#listing_car_type').val() || 'car' : carTypeRadio.find('input:checked').val();
  var preselectedMakeId = makeSelect.attr('data-selected');

  updateMakeSelect(makeSelect);
  updateBodySelect(bodySelect);
  if (preselectedMakeId) {
    updateModelSelect(preselectedMakeId, modelSelect);
  }

  carTypeRadio.on('change', function () {
    selectedCarType = $(this).find('input:checked').val();

    resetSelect(modelSelect);
    updateMakeSelect(makeSelect);
    updateBodySelect(bodySelect);

    mobileSelects.removeClass('filled');
  });

  makeSelect.on('change', function () {
    var makeId = $(this).val();

    updateModelSelect(makeId, modelSelect);
  });

  function updateMakeSelect(makeSelect) {
    var url = '/api/v1/listing/available-search-data/car-type-brands/' + selectedCarType;

    updateDynamicSelect(url, makeSelect);
  }

  function updateModelSelect(makeId, modelSelect) {
    var url = '/api/v1/listing/available-search-data/makes_with_id/' + makeId + '/' + selectedCarType;

    if (makeId === ' ') {
      modelSelect.html("<option value=' '>" + I18n.t('js.all') + "</option>");
      modelSelect.prop('disabled', true);
      modelSelect.trigger('chosen:updated');
      animateLabel(modelSelect.next()[0]);
      return;
    }

    updateDynamicSelect(url, modelSelect);
  }

  function updateBodySelect(bodySelect) {
    var url = '/api/v1/listing/available-search-data/body_types/with_locale/' + selectedCarType + '?locale=' + I18n.locale;

    updateDynamicSelect(url, bodySelect);
  }

  function updateDynamicSelect(url, selectToUpdate) {
    if (typeof selectedCarType === 'undefined' || !selectedCarType.length) {
      resetSelect(selectToUpdate);
      return;
    }

    selectToUpdate.prop('disabled', true);
    selectToUpdate.trigger('chosen:updated');
    $.ajax({
      method: 'GET',
      url: location.origin + url
    }).done(function (response) {
      var options = '<option value=""></option>';
      if (selectToUpdate.data('withAll') === true) {
        options = "<option value=' '>" + I18n.t('js.all') + "</option>";
      }

      $.each(response, function (_index, option) {
        options += '<option value=' + option.id + '>' + option.name + '</option>'
      });

      selectToUpdate.html(options);

      var selected = selectToUpdate.attr('data-selected');
      if (selected) {
        selectToUpdate.val(selected);
        selectToUpdate.attr('data-selected', null);
      }

      selectToUpdate.prop('disabled', false);
      selectToUpdate.trigger("chosen:updated");
      checkSelectWithAimatedLabel(selectToUpdate);
    });
  }

});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/ajax_selects.js